.advance-loading {
  display: grid;
  place-items: center;
  width: 100%;
  height: 100%;
  color: var(--gw-primary-purple, hsl(260, 47%, 49%));
  opacity: 0;
  animation: fadeIn 500ms ease 0ms forwards;
}
@keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
